export const getTZString = () => {
  // could use moment.tz.guess() instead, but Intl API is well supported
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
